const mailchimp = () => {

    // Handle GDPR checkbox click
    document.querySelectorAll('.js__gdpr').forEach(el => {
        el.addEventListener('click', function(e) {
            e.preventDefault();
            let childInput = this.querySelector('input');
            if (this.classList.contains('checked')) {
                childInput.checked = false;
                this.classList.remove('checked');
            } else {
                childInput.checked = true;
                this.classList.add('checked');
            }
        });
    });

    let loader = '<div class="loader"><div class="ball-clip-rotate"><div></div></div></div>';

    // Handle form submit
    document.querySelectorAll('.js__signup').forEach(el => {
        el.addEventListener('submit', function(e) {
            e.preventDefault();
            let email = this.querySelector('#email').value;
            let message = this.parentElement.querySelector('#message');
            message.innerHTML = '';

            let gdprCheckbox = this.querySelector('#gdpr');
            if (gdprCheckbox.checked && email.length > 0) {

                // Making an AJAX call using the Fetch API
                fetch('/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: new URLSearchParams({
                        'action': 'mailchimp',
                        'email': email,
                    }),
                }).then(response => {
                    return response.json();
                }).then(data => {
                    this.parentElement.querySelector('.loader-wrap .loader').remove();
                    message.classList.add('success');
                    message.innerHTML = data.message;
                }).catch(error => {
                    this.parentElement.querySelector('.loader-wrap .loader').remove();
                    message.classList.add('error');
                    message.innerHTML = error.message;
                });

                // Show loader before the AJAX request is made
                message.classList.remove('success', 'error');
                this.style.display = 'none';
                this.parentElement.querySelector('.loader-wrap').innerHTML = loader;
            } else {
                message.classList.remove('success');
                message.classList.add('error');
                message.innerHTML = '<p>Please make sure email is correct and the GDPR checkbox is checked.</p>';
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.js__signup')) {
        mailchimp();
    }
});